import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class DataService {
  private data: any;
 
  setData(data: any): void {
    this.data = data;
    console.log(this.data);
  }
 
  getData(): any {
    return this.data;
  }
}